<template>
    <div>
        <rotinastarefa :optarefacmp="optarefa" :idtarefacmp="idtarefa" @AtualizaTarefas="mtdcarregadash()"></rotinastarefa>
        <div class="container-fluid" style="margin-top: -15px;">
            <div v-show="isloading" class="row">
                   <dashboard_skeleton></dashboard_skeleton>
            </div>
          
            <div v-show="!isloading" class="row" style="height: calc(100vh - 55px); max-height: calc(100vh - 55px);">
                <div class="container-fluid d-flex flex-column pt-2 pb-3">
                    <div class="row">
                        <!-- historico atividades -->
                        <div class="col-md-12 col-lg-4 margin-card" style="height: fit-content;">
                            <div class="card card-historico" style=" box-shadow: 0 5px 8px rgba(0,0,0,0.05); border-radius: 10px; margin-bottom: 5px;" >
                                <div class="card-header card-dash" style="display: flex; justify-content: space-between;">
                                    <span class="tit-card-dash"  style="user-select: none;" ><i class="fa fa-clock" style="margin-right: 5px; color: #6c757d;"></i>Histórico </span>
                                    <span class="tit-card-dash" style=" font-weight: 300!important; font-size: 12px!important; user-select: none;"><i class="fa fa-calendar"></i> {{ pdatv }} </span>
                                    <span style=" cursor: pointer; color: #666666;" @click.prevent="mdlhistoricoatv()"  title="Visualizar histórico completo">Visualizar ></span>
                                </div>
                                <div class="card-body p-0 d-flex justify-content-center flex-column" style="min-height: 108px;">
                                    <div class="col-md-12">
                                        <template v-if="lsthistorico.length > 0">
                                            <ul class="mb-auto" style="margin-bottom: 5px; text-align: left; padding: 0;">
                                                <li v-for="(item, indice) in lsthistorico.slice(-4).reverse()" :key="indice"
                                                    class="li-item-card-dash"
                                                    style="height: 15px; margin-bottom: 10px; margin-top: 5px;">
                                                    <ul class="pl-0 d-flex justify-content-between align-items-center" style="user-select: none;">
                                                        <span style="margin-right: 5px; margin-left: 5px; min-width: 105px;">
                                                            Hoje às {{ item.dthratividade.split(' ')[1].slice(0, 5) }}
                                                        </span>
                                                        <span class="badge text-truncate"
                                                            :class="{
                                                                'badge-success': item.descricao.includes('Incluiu'),
                                                                'badge-warning': item.descricao.includes('Alterou'),
                                                                'badge-danger': item.descricao.includes('Excluiu'),
                                                                'badge-secondary': !(
                                                                    item.descricao.includes('Incluiu') ||
                                                                    item.descricao.includes('Alterou') ||
                                                                    item.descricao.includes('Excluiu')
                                                                )
                                                            }"
                                                            style="max-width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-size: 0.9em; padding: 0.3em 0.5em;">
                                                            {{ item.descricao }}
                                                        </span>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </template>
                                        <template v-else>
                                            <div class="container-sem-hist">
                                                <div class="sem-historico-img">
                                                    <img src="icone-sem-hist.svg" alt="">
                                                </div>
                                                <div class="sem-historico">
                                                    <span>Você ainda não realizou nenhuma ação.</span>
                                                    <p class="mb-0">
                                                        Suas atividades diárias aparecerão aqui.
                                                    </p>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>                    
                        </div>
                        <!-- favoritos -->
                        <div class="col-md-12 col-lg-4 margin-card" style="height: fit-content;">
                            <div class="card card-atalhos" style="box-shadow: 0 5px 8px rgba(0,0,0,0.05); border-radius: 10px; margin-bottom: 5px;">
                                <div class="card-header card-dash">
                                    <span class="tit-card-dash">
                                        <i class="fa fa-star-o" style="margin-right: 5px; "></i>Favoritos
                                    </span>
                                    <span style="float: right; cursor: pointer; color: #666666;" @click.prevent="mdlfavoritos()"  title="Visualizar lista de favoritos">Visualizar ></span>
                                </div>
                                <div class="card-body px-3 py-2 d-flex justify-content-center body-favoritos" style="min-height: 108px;">
                                    <div class="row" style="width: 100%;">
                                        <template v-if="lstfavoritos.length > 0">
                                            <div class="col-12 col-sm-6 col-md-4 mb-2 px-2" v-for="(item, indice) in lstfavoritos.slice(-6).reverse()" :key="indice">
                                                <div class="card cardfav d-flex align-items-center justify-content-center"
                                                    style="text-align: center; box-shadow: 0 2px 8px rgba(0,0,0,0.05); padding: 4px; overflow: hidden;" 
                                                    @click.prevent="mtdgotofav(item.routerfav)" :title="item.routerfav">
        
                                                    <div class="d-flex align-items-center w-100 pr-2" style="overflow: hidden;">
                                                        <i :class="mtdiconefav(item.codop)" 
                                                        style="margin-right: 5px; margin-left: 8px; font-size: 14px; color: #6c757d; flex-shrink: 0;">
                                                        </i>
                                                        
                                                        <span class="text-truncate" style="color: #6c757d; font-size: 13px; max-width: 70%;">
                                                            {{ formatarDescricaoFavorito(item.chave, item.codop) }} 
                                                        </span>
        
                                                        <i class="fa fa-arrow-right ml-auto" style="color: #6c757d; opacity: .35;"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="container-sem-fav">
                                                <div class="sem-favoritos-img">
                                                    <img src="icone-sem-fav.svg" alt="">
                                                </div>
                                                <div class="sem-favoritos">
                                                    <span>Nenhum favorito encontrado!</span>
                                                    <p class="mb-0" @mouseover="dicaFavoritos = true" @mouseleave="dicaFavoritos = false">
                                                        <i class="fa fa-question-circle" aria-hidden="true"></i> Saiba como adicionar atalhos para os módulos que você mais usa.
                                                    </p>
                                                    <transition name="fade">
                                                        <div v-show="dicaFavoritos" class="tooltip-message-fav" @mouseover="dicaFavoritos = true" @mouseleave="dicaFavoritos = false">
                                                            <img :src="'https://'+$store.state.usuario.adrsrv+'/controller/imagens/saibacomo-fav.gif'" alt="">
                                                            <div>
                                                                <p>Para adicionar um atalho, acesse o módulo desejado e clique no ícone de estrela no canto superior direito.</p>
                                                            </div>
                                                        </div>
                                                    </transition>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- banner anuncio -->
                        <div class="col-md-12 col-lg-4 mb-3" style=" height: fit-content; ">
                            <div v-if="lstatzs.length > 0" id="carouselpubli" class="carousel slide" data-ride="carousel" data-interval="3000">
                                <div class="carousel-inner">
                                    <div v-for="(item, indexItem) in publiconteudoexibir" :key="indexItem" :class="['carousel-item', { active: indexItem === 0 }]">
                                        <img
                                        v-if="item.arquivos && item.arquivos.length > 0 && item.arquivos[0].linkarquivo" class="d-block w-100 imgcardpubli"
                                        :src="'https://rillsoft.app/sacweb/controller/' + item.arquivos[0].linkarquivo" alt="Imagem"
                                        style="border-radius: 15px; max-height: 152px;  cursor: pointer;" @click.prevent="mtdabrirlink(item.link)"
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" >
                        <!-- card novidades -->
                        <div class="col-md-12 col-lg-8 d-flex margin-card" >
                            <div class="card" style=" box-shadow: 0 5px 8px rgba(0,0,0,0.05); border-radius: 10px; height: 100%; ">
                                <div class="card-header card-dash">
                                    <span class="tit-card-dash">Novidades</span>
                                </div>
                                <div class="card-body">
                                    <div class="row h-100">
                                        <!-- conteudo da novidade -->
                                        <div class="col-sm-12 col-md-9 col-lg-9 cardnews">
                                            <div class="card-body" style="height: 100px; user-select: none; padding-top: 0 !important">
                                                <div class="row">
                                                    <div class="col-12">
                                                    <!-- 0 - Novidades || 1 - Publicidade -->
                                                    <div v-if="newsconteudoexibir" :key="newsconteudoexibir.idcarrossel" id="carouselArquivos" class="carousel slide" data-ride="carousel">
                                                        <div class="carousel-inner">
                                                            <div v-for="(imagemcarrossel, index) in newsconteudoexibir.arquivos" :key="index "
                                                                :class="['carousel-item', { active: index === 0 }]">
                                                                <img class="d-block w-100 imgcardnews"
                                                                    :src="'https://rillsoft.app/sacweb/controller/' + imagemcarrossel.linkarquivo"
                                                                    alt="Imagem" style="border-radius: 15px;" @click.prevent="mtdabrirlink(newsconteudoexibir.link)"> 
                                                            </div>
                                                        </div>
                                                        <a class="carousel-control-prev" href="#carouselArquivos" role="button" data-slide="prev">
                                                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                            <span class="sr-only">Anterior</span>
                                                        </a>
                                                        <a class="carousel-control-next" href="#carouselArquivos" role="button" data-slide="next">
                                                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                            <span class="sr-only">Próximo</span>
                                                        </a>
                                                    </div>
                                                    </div>
                                                    <div v-if="newsconteudoexibir" class="col-12" 
                                                        v-html="newsconteudoexibir.corpo">
                                                    </div>
                                                </div>
                                                <hr>
                                                <div class="row " v-if="newsconteudoexibir.feedback">
                                                    <div class="col-12 d-flex " style="margin-left: 8px;">
                                                        <p>Obrigado pelo feedback<i class="fa fa-check-square-o" style="margin-left: 5px; color: green;"></i></p> 
                                                    </div>
                                                </div>
                                                <div class="row" v-if="newsconteudoexibir.feedback == null">
                                                    <div class="col-sm-12 col-md-12 col-lg-8">
                                                        <textarea class="form-control center" placeholder="Digite seu comentário" rows="2" v-model="newscomentario"></textarea>
                                                    </div>
                                                    <div class="col-sm-12 col-md-12 col-lg-2 d-flex">
                                                        <button type="button" class="btn btn-sm" :class="parseInt(newslike) === 1 ? 'btn-green' : ''" @click.prevent="mtdnewslike(1)">
                                                            <i class="fa fa-thumbs-up"></i>
                                                        </button>
                                                        <button type="button" class="btn btn-sm" :class="parseInt(newsdeslike) === 1 ? 'btn-red' : ''" @click.prevent="mtdnewslike(2)">
                                                        <i class="fa fa-thumbs-down"></i>
                                                        </button>
                                                    </div> 
                                                    <div class="col-2">
                                                        <button  type="button" class="btn btn-success btn-sm" @click.prevent="mtdnewsfeeadback(newsconteudoexibir.id)">Enviar</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- cards lateral novidades -->
                                        <div class="col-sm-12 col-md-3 col-lg-3 lstnews">
                                            <div v-for="(atz, indice) in lstatzs.filter(pub => pub.tpatualizacao == 0)" :key="indice">
                                                <div @click.prevent="visualizanews(atz)" style="cursor: pointer;" class="card card-custom">
                                                    <div class="card-body listanews p-1 d-flex flex-column" :class="['listanews', { 'card-visualizado': newsconteudoexibir.id !== atz.id }]">
                                                        <div>
                                                            <span class="card-descricao">{{ atz.descricao }}</span>
                                                        </div>
                                                        <div>
                                                            <span v-if="atz.feedback == 1" style="margin-top: 5px;">
                                                                <small>Feedback enviado<i class="fa fa-check-square-o" style="margin-left: 5px; color: green;"></i></small>
                                                            </span>
                                                        <span v-else style="margin-top: 5px;">
                                                            <small>Feedback pendente<i class="fa fa-exclamation-triangle" style="margin-left: 5px; color: #ffc107;"></i></small>
                                                        </span>
                                                        </div>
                                                        <div class="d-flex justify-content-between">
                                                            <span>Postado em: </span>
                                                            <div>
                                                                <span class="card-data">
                                                                    {{ formatarDataPadrao(atz.dtcadastro) }}
                                                                </span>
                                                                <i class="fa fa-calendar-o ml-1"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer" style="background-color: transparent; padding-top: 5px;">
                                    <div class="row">
                                        <div class="col-12" style="display: flex; justify-content: center; padding: 5px;">
                                            <i class="fa fa-sort-desc bounce-icon" aria-hidden="true" style="margin-right: 5px;"></i>
                                            <span> Role para baixo</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                            <!-- card tarefas -->
                        <div class="col-md-12 col-lg-4" style="height: calc(100dvh - 255px);">
                            <div class="card estilo_tarefas" style=" box-shadow: 0 5px 8px rgba(0,0,0,0.05); border-radius: 10px; height: 100%;">
                                <div class="card-header card-dash" style="padding-top: 7px!important; padding-bottom: 7px!important;">
                                    <div class="row">
                                        <div class="col-5 col-sm-5 col-md-4" style="margin-top: 5px!important;">
                                            <span class="tit-card-dash">Minhas tarefas</span>
                                        </div>
                                        <div class="col-7 col-sm-7 col-md-8 col-lg-8 text-right">
                                            <select v-model="filtrotarefa" name="sbsituacaotarefas" class="form-control form-control-sm selectpicker" id="sbsituacaotarefas" @change="mtdBuscaFiltradaTarefas()" multiple data-actions-box="true">
                                                <option data-content="<span class='badge badge-primary bdg-digitacao bgd-st-tarefa'>Em dia</span>" value="0"></option>
                                                <option data-content="<span class='badge badge-primary bdg-enviada bgd-st-tarefa'>Atrasadas</span>" value="2"></option>
                                                <option data-content="<span class='badge badge-primary bdg-autorizada bgd-st-tarefa'>Finalizadas</span>" value="1"></option>
                                            </select>
                                        </div>                                        
                                    </div>
                                </div>
                                <div class="card-body" style="background: #f8f9fc26; padding-top: 0px; padding-bottom: 18px; overflow:auto;">
                                    <div class="row">
                                        <div v-show="lsttarefas.length > 0" class="col-md-12">
                                            <div v-for="(tarefa, indice) in lsttarefas" :key="indice" class="card estilo_tarefas" style="margin-top: 15px;" @click.prevent="mtdgerenciartarefa(tarefa.id)">
                                                <div class="card-body" style="padding: 10px;">
                                                    <div class="row">
                                                        <div class="col-12" style="margin-bottom: 15px;">
                                                            <template v-if="parseInt(tarefa.sttarefa) === 1">
                                                                <span class="span-status-tarefa tarefa-finalizada text-center" title="Tarefa finalizada">
                                                                    <i class="fa fa-calendar-check-o icone-status-tarefa"></i>
                                                                </span>
                                                            </template>
                                                            <template v-else-if="parseInt(tarefa.sttarefa) === 0 && mtddatatarefamenor(tarefa.dtvisualizar)">
                                                                <span class="span-status-tarefa tarefa-normal text-center" title="Tarefa em dia">
                                                                    <i class="fa fa-lightbulb-o icone-status-tarefa"></i>
                                                                </span>                                                                
                                                            </template>
                                                            <template v-else>
                                                                <span class="span-status-tarefa tarefa-atrasada text-center" title="Tarefa atrasada">
                                                                    <i class="fa fa-clock-o icone-status-tarefa"></i>
                                                                </span>                                                                
                                                            </template>                                                            
                                                            <h5 class="tit-tarefa" v-bind:title="tarefa.titulo">{{ tarefa.titulo }}</h5>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="dv-cal"><i class="fa fa-calendar" style="font-size: 12px; color: #aaaaaa;"></i></div>
                                                            <span class="tit-data">{{ mtdformadardataextenso(mtdtransformadata(tarefa.dtvisualizar+'T00:00:00')) }}</span>
                                                        </div>
                                                        <div class="col-12 text-right" style="margin-top: 8px;">
                                                            <div v-if="tarefa.checklist.length > 0" class="progress">
                                                                <div class="progress-bar pb-tarefa" v-bind:style="{width: tarefa.concluida + '%'}" title="Percentual de conclusão baseado na checklist">{{ tarefa.concluida }}%</div>
                                                            </div>                                                            
                                                        </div>                                                        
                                                        <div class="col-12 text-right" style="margin-top: 8px;">
                                                            <template v-for="(participante, indicep) in tarefa.participantes">
                                                                <img v-if="parseInt(participante.marcado) === 1" :key="indicep" v-bind:src="pathfotos+participante.foto" class="img-usutarefa" data-toggle="tooltip" v-bind:title="participante.nomeusu">
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>                                             
                                        </div>
                                        <button type="button" class="btn btn-primary btn-purple" id="btnovatarefa" title="Adicionar nova tarefa" @click.prevent="mtdnovatarefa()"><i class="fa fa-plus"></i></button>                                        
                                    </div>                                    
                                </div>
                            </div>                    
                        </div>  
                    </div>
                </div>
            </div>              
        </div>
        <!-- modal historico atvidade -->
        <div class="modal fade" id="mdlhistoricoatv" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content" style="border-radius: 15px; box-shadow: 0 10px 20px rgba(0,0,0,0.05);">
                <div class="card-body p-0" style="min-height: 108px;">
                    <div class="row">
                    <div class="col-12 titulo_historico d-flex" style="background-color: #1e2b37; color: white;">
                        <div class="col-11 text-center" style="margin-top: 5px;">
                        <h5 style="margin-left: 25px;">HISTÓRICO DE AÇÕES</h5>
                        </div>
                        <div class="col-1">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Fechar" style="margin-top: 5px;">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        </div>
                    </div>
                    </div>

                    <div class="row" style="max-height: 700px; overflow-y: auto;" v-if="lsthistorico.length > 0">
                    <div class="col-12" v-for="(item, indice) in lsthistorico.slice().reverse()" :key="indice" style="margin-top: 10px;">
                        <div class="d-flex align-items-start px-3 flex-wrap">
                        <i class="fa"
                            :class="buscarIconeEcor(item.descricao).icon"
                            :style="{ color: buscarIconeEcor(item.descricao).color, marginRight: '7px', minWidth: '20px', marginTop: '4px' }">
                        </i>
                        <span class="text-muted mr-2 text-nowrap" style="flex-shrink: 0; font-size: 14px;">
                            {{ mtdformadardataextenso(mtdtransformadata(item.dthratividade + 'T00:00:00'), true) }}
                        </span>
                        <span class="badge"
                                :class="{
                                'badge-success': item.descricao.includes('Incluiu'),
                                'badge-warning': item.descricao.includes('Alterou'),
                                'badge-danger': item.descricao.includes('Excluiu'),
                                'badge-secondary': !(
                                    item.descricao.includes('Incluiu') ||
                                    item.descricao.includes('Alterou') ||
                                    item.descricao.includes('Excluiu')
                                )
                                }"
                                style="max-width: 100%; word-break: break-word; white-space: normal; font-size: 0.9em; padding: 0.3em 0.5em;">
                            {{ item.descricao }}
                        </span>
                        </div>
                        <hr class="my-2" />
                    </div>
                    </div>

                    <div class="row justify-content-center mt-3" v-else>
                    <span>Histórico de ações vazio</span>
                    </div>
                </div>
                </div>
            </div>
            </div>
        <!-- modal favoritos -->
        <div class="modal fade" id="mdlfav" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-sm modal-dialog-scrollable" role="document">
                <div class="modal-content" style="border-radius: 15px; box-shadow: 0 10px 20px rgba(0,0,0,0.1); overflow: hidden;">
                    
                    <div class="modal-header" style="background-color: #1e2b37; color: white; border-bottom: none;">
                        <h5 class="modal-title mx-auto">MEUS FAVORITOS</h5>
                        <button type="button" class="close position-absolute" style="right: 10px;" data-dismiss="modal" aria-label="Fechar">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body p-3" style="max-height: 500px; overflow-y: auto;">

                        <div v-if="lstfavoritos.length > 0">
                            <div class="d-flex flex-column align-items-center">
                                <div
                                    class="card mb-2 px-3 py-2 w-100"
                                    style="box-shadow: 0 2px 8px rgba(0, 0, 0, 0.10) !important; border-radius: 8px; cursor: pointer;"
                                    v-for="(item, indice) in lstfavoritos.slice().reverse()"
                                    :key="indice"
                                    @click.prevent="mtdgotofav(item.routerfav)"
                                >
                                    <div class="d-flex align-items-center justify-content-between w-100">
                                        <div class="d-flex align-items-center" style="overflow: hidden;">
                                            <i :class="mtdiconefav(item.codop)" style="margin-right: 8px; font-size: 14px; color: #6c757d; flex-shrink: 0;"></i>
                                            <span class="text-muted text-truncate" style="font-size: 13px; overflow: hidden; text-overflow: ellipsis;">
                                                {{ formatarDescricaoFavorito(item.chave, item.codop) }}
                                            </span>
                                        </div>
                                        <i class="fa fa-close"
                                            style="color: #6c757d; cursor: pointer; margin-left: 10px;"
                                            @click.stop.prevent="mtdremovefav(item.routerfav)">
                                        </i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="text-center mt-4 text-muted">
                            Lista de favoritos vazia
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import util from '../utilitarios/util.js';
import * as moment from 'moment';
import RotinasTarefa from '../components/cmprotinastarefa.vue';
import Skeletondashboard from '../components/cmpskeletondashboard.vue';
import { Modal } from 'bootstrap';
import router from '../router.js';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
    name: 'telaprincipal',
		components: {
            'rotinastarefa'         : RotinasTarefa,
            'dashboard_skeleton'   : Skeletondashboard,
            VueSlickCarousel
		},

		data: function() {
			return {   
                utodasfiliais 		    : this.$store.state.usuario.todasfiliais, 
                pathfotos               : this.$store.state.configpaths.pathimagens,
                patharquivos            : this.$store.state.configpaths.pathtarefas,//diretório dos arquivos das tarefas
                lstresultadofaturamento : [],
                lstatzs                 : [],
                lsthistorico            : [],
                filtrotarefa            : [],
                infosistema             : "",
                
                // Componentes da Novidades
                newsconteudoexibir      : {},
                publiconteudoexibir     : {},
                newscomentario          :"",
                newslike                : 0,
                newsdeslike             : 0,
                settings                :{
                    dots: true,
                    infinite: true,
                    speed: 500,
                    adaptiveHeight: true,
                    autoplaySpeed: 3000,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    arrows: true,
                },
                
                // favoritos
                lstfavoritos            : [],
                dicaFavoritos           : false,


                mediafaturamento        : 0,
                displayperiodo          : '',
                legendasfinanceiro      : [],
                dadosfinanceiro         : [],
                legendasvendedores      : [],
                dadosvendedores         : [],
                dadospedcompra          : [],
                legendapedcompra        : [],
                lstresumopedidos        : [],

                agrupamentohoras        : [],
                agrupamentoquantidades  : [],
                hrmaior                 : 0,

                totalpedcompra          : 0,
                totalfin                : 0,
                visualizartop5          : 0,//0 - Valor, 1 - Quantidade
                qtdnotaspendentes       : 0,
                lsttop5provl            : [],
                lsttop5proqtd           : [],
                lsttop10pro             : [],
                lsttarefas              : [],
                pdtini                  : moment().format('DD/MM/YYYY'),
                pdtfim                  : moment().endOf('month').format('DD/MM/YYYY'),//moment().format('DD/MM/YYYY'),
                pdatv                   : new Date().toLocaleDateString('pt-BR'),
                diaselecionado          : 1,
                lstfiliais              : [],

                //variáveis para manipulação das tarefas
                optarefa                : 0,
                idtarefa                : 0,
                showpopover             : false,

                //variáveis da meta
                idfilialmeta            : null,
                dadosmetas              : [],
                mesmeta                 : 1,
                anometa                 : 1,
                anoslistameta           : [],
                gruponomes              : [],
                series                  : [],
                totalgeralvendasmetas   : 0,
                totalgeralmeta          : 0,

                // - Variável de margem de lucro geral
                margemlucrogeral        : 0,
                vtotalservicos          : 0,

                // - Variáveis para top 5 produtos mais vendidos por vendedor padrão
                visualizartop5vendedorpadrao        : 0,
                lsttop5provlvendedorpadrao          : [],
                lsttop5provendedorpadrao            : [],
                lsttop5proqtdvendedorpadrao         : [],

                //skeleton 
                isloading                           : true,

                // - Permissão do usuário para visualizar dados do vendedor pardrão e meta
                usuarioPermissaoVendedorPadraoMetas : true,

                // - Variáveis para dados de técnicos
                legendastecnicos        : [],
                dadostecnicos           : [],

                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                }               
            }
        },
		methods:{
            async mtdcarregadash(){
                let vself = this;
                vself.isloading = true;
                try {
                    vself.lstatzs               = await vself.listaratzs();
                    vself.lsthistorico          = await vself.mdthistoricoatv();
                    vself.lstfavoritos          = await vself.mtdlistafavs();
                    $('#sbsituacaotarefas').selectpicker('val', ['0', '2']);    
                    vself.lsttarefas            = await vself.listatarefas();
                    // vself.newsconteudoexibir    = vself.lstatzs[0] || {};
                    this.$nextTick(() => {
                        $('#carouselpubli').carousel({
                        interval: 3000
                        });
                    });
                } catch (error) {
                    console.log('Erro ao carregar dados iniciais:', error);
                }

                vself.utodasfiliais = vself.$store.state.usuario.todasfiliais;
                $('#sbsituacaotarefas').selectpicker({
                    noneResultsText : 'Sem resultados',
                    noneSelectedText: 'Nenhuma selecionada',
                    selectAllText   : 'Todas',
                    deselectAllText : 'Nenhuma'
                });

                util.atzverificalib(this, true);

                let dataatual  = new Date();
                let anoatual   = dataatual.getFullYear();

                this.anometa   = parseInt(anoatual);
                this.mesmeta   = parseInt(dataatual.getMonth()) + 1;
                try{
                    this.infosistema = window.localStorage.getItem('receberinfsistema');
                }catch(erro){
                    console.error(error);
                    this.infosistema = '';
                }

                this.anoslistameta = [];
                $('#mdlnews').on('hidden.bs.modal', function (e) {
                    vself.mtdnewslike(3)
                });
                vself.isloading = false;
            },
            // - Método para extrair informações do 
            //banco de dados referente a metas do vendedor padrão
            mtdvendedorpadraoinfo() {
            
                var vself = this;
                let parametros = [
                    {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},                    
                    {parametro: 'op',           valor : 'vendedorpadraometa'},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'dtinicio',     valor : vself.pdtini},
                    {parametro: 'dtfim',        valor : vself.pdtfim},
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
                retorno.then(function (response) {
                    //Funções a serem feitas quando a requisição for bem sucedida
                    let vendedorMeta          = response.data[0];
                    let vendedorMetaAtingida  = response.data[1];
                    let vendedorMetaRestante  = vendedorMeta - vendedorMetaAtingida;
                    // window.alert(vendedorMeta);
                    // console.log(vendedorMeta);

                    if (vendedorMetaRestante < 0) {
                        vendedorMetaRestante = 0;
                    }
                    vself.dadosmetavendedorpadrao = [
                        {value: parseFloat(vendedorMetaAtingida)    , name: 'ATINGIDA'},
                        {value: parseFloat(vendedorMetaRestante)    , name: 'RESTANTE'}
                    ];
                    vself.legendasmetavendedorpadrao = util.gerardadoslegendagrafico(vself.legendasmetavendedorpadrao);
                }).catch(function (response) {
                });  
            },
            mtddatatarefamenor(datatarefa){
                return util.datamenor(datatarefa);
            },
            mtdformadardataextenso(data, mostrahr) {
                if (!mostrahr) {
                    return util.dataextenso(util.InverterData(data) + 'T00:00:00');
                }else{
                    let vdthr = data.split('T');
                    let vhr   = vdthr[1].split(':');
                    return util.dataextenso(util.InverterData(data) + 'T00:00:00')+' às '+vhr[0]+':'+vhr[1];
                }
            },
            mtdtransformadata: function(dttrasnf){
                return util.formatadatahrdb(dttrasnf);
            },
            formatarDataPadrao(dataBanco) {
                const partes = dataBanco.split('-');
                const ano = partes[0];
                const mes = partes[1];
                const dia = partes[2];

                return `${dia}/${mes}/${ano}`;
            },           
            mtdmesextenso(mes){
                switch (parseInt(mes)) {
                    case 1:
                        return 'JANEIRO'
                        break;
                    case 2:
                        return 'FEVEREIRO'
                        break;
                    case 3:
                        return 'MARÇO'
                        break;
                    case 4:
                        return 'ABRIL'
                        break;     
                    case 5:
                        return 'MAIO'
                        break;     
                    case 6:
                        return 'JUNHO'
                        break;     
                    case 7:
                        return 'JULHO'
                        break;                                                                                                                           
                    case 8:
                        return 'AGOSTO'
                        break;     
                    case 9:
                        return 'SETEMBRO'
                        break;     
                    case 10:
                        return 'OUTUBRO'
                        break;     
                    case 11:
                        return 'NOVEMBRO'
                        break;                                                                                 
                    case 12:
                        return 'DEZEMBRO'
                        break;                        
                }
            },
			mtdformatavalordecimal(valor){
				return util.formatarvalor(valor, '');
            },
            mtdmediafaturados(){
                let mediafat = 0;
                // for (let i = 0; i < this.lstresumopedidos.length; i++) {                    
                //     if (parseInt(this.lstresultadofaturamento[i].stpedido) === 1) {
                //         mediafat = this.lstresultadofaturamento[i].totalpedidos / this.lstresultadofaturamento[i].qtdpedidos;
                //     }                    
                // }
                if(this.lstresumopedidos){
                    mediafat = this.lstresumopedidos.totalfaturado / this.lstresumopedidos.qf;
                }
                return mediafat;
            }, 
            mtdremoveatrasadas(){
                let tarefas = $('#sbsituacaotarefas').selectpicker('val');
                for (let i = 0; i < tarefas.length; i++) {
                    if (parseInt(tarefas[i]) === 2){
                        return false;
                    }                       
                }
                return true;
            },   
            mtdremoveemdia(){
                let tarefas = $('#sbsituacaotarefas').selectpicker('val');
                for (let i = 0; i < tarefas.length; i++) {
                    if (parseInt(tarefas[i]) === 0){
                        return false;
                    }                       
                }
                return true;
            },    
            async listatarefas(){
                const vself = this;
                let filtrotarefas   = '';
                if (vself.mtdremoveatrasadas()){
                    filtrotarefas   = ' and pt.idusuario='+vself.$store.state.usuario.id+' and t.sttarefa in ('+$('#sbsituacaotarefas').selectpicker('val')+')';                
                }else{
                    if ($('#sbsituacaotarefas').selectpicker('val').length > 0){
                        filtrotarefas   = ' and pt.idusuario='+vself.$store.state.usuario.id+' and t.sttarefa in ('+$('#sbsituacaotarefas').selectpicker('val')+', 0)';                
                    }else{
                        filtrotarefas   = ' and pt.idusuario='+vself.$store.state.usuario.id+' and t.sttarefa < 0';                                        
                    }
                }
                const parametros = [
                    { parametro: 'idclientesac',    valor: vself.$store.state.usuario.idclientesac },
                    { parametro: 'idusuario',       valor: vself.$store.state.usuario.id },
                    { parametro: 'op',              valor: 'consultatarefas' },
                    { parametro: 'patharquivos',    valor: vself.patharquivos },
                    { parametro: 'filtrotarefas',   valor: filtrotarefas },
                ];

                try {
                    const response = await util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/telaprincipal.php');
                    return response.data || [];
                } catch (error) {
                    vself.$toastr.e('Ocorreu um erro ao carregar as novidades: ' + (error?.data || error), 'Informação!');
                    return [];
                }
                
            },
            async mtdfiltratarefas(){
                console.log('Inicia tarefas');
                const vself = this;
                let filtrotarefas   = '';
                if (vself.mtdremoveatrasadas()){
                    filtrotarefas   = ' and pt.idusuario='+vself.$store.state.usuario.id+' and t.sttarefa in ('+$('#sbsituacaotarefas').selectpicker('val')+')';                
                }else{
                    if ($('#sbsituacaotarefas').selectpicker('val').length > 0){
                        filtrotarefas   = ' and pt.idusuario='+vself.$store.state.usuario.id+' and t.sttarefa in ('+$('#sbsituacaotarefas').selectpicker('val')+', 0)';                
                    }else{
                        filtrotarefas   = ' and pt.idusuario='+vself.$store.state.usuario.id+' and t.sttarefa < 0';                                        
                    }
                }
                const parametros = [
                    { parametro: 'idclientesac',    valor: vself.$store.state.usuario.idclientesac },
                    { parametro: 'idusuario',       valor: vself.$store.state.usuario.id },
                    { parametro: 'op',              valor: 'consultatarefas' },
                    { parametro: 'patharquivos',    valor: vself.patharquivos },
                    { parametro: 'filtrotarefas',   valor: filtrotarefas },
                ];

                try {
                    const response = await util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/telaprincipal.php');
                    let lsttmp  = JSON.parse(JSON.stringify(response.data));
                    let lsttmp2 = []
                    if (vself.mtdremoveatrasadas()){
                        for (let x = 0; x < lsttmp.length; x++) {
                            if (parseInt(lsttmp[x].sttarefa) === 1){
                                lsttmp2.push(lsttmp[x]);
                            }else if (parseInt(lsttmp[x].sttarefa) === 0 && vself.mtddatatarefamenor(lsttmp[x].dtvisualizar)){
                                lsttmp2.push(lsttmp[x]);
                            }                            
                        }
                    }else{
                        lsttmp2          = lsttmp;
                    }
    
                    if (vself.mtdremoveemdia()){
                        lsttmp           = JSON.parse(JSON.stringify(lsttmp2));
                        lsttmp2 = [];
    
                        for (let x = 0; x < lsttmp.length; x++) {
                            if (parseInt(lsttmp[x].sttarefa) === 1){
                                lsttmp2.push(lsttmp[x]);
                            }else if (parseInt(lsttmp[x].sttarefa) === 0 && !vself.mtddatatarefamenor(lsttmp[x].dtvisualizar)){
                                lsttmp2.push(lsttmp[x]);
                            }                            
                        }
                    }
                    console.log('Finaliza tarefas');
                    return lsttmp2;
                } catch (error) {
                    vself.$toastr.e('Ocorreu um erro ao carregar as tarefas: ' + (error?.data || error), 'Informação!');
                    return [];
                }

            },
            async mtdBuscaFiltradaTarefas() {
                const resultado = await this.mtdfiltratarefas();
                this.lsttarefas = resultado;
            },
            mtdmudatop5(){
                this.visualizartop5 = parseInt(this.visualizartop5) === 0 ? 1 : 0;
            },
            mtdnovatarefa(){
                this.optarefa = 0;
                this.idtarefa = 0;
                let payload = {
                    abrirtela    : true			
                };
                this.$store.commit('ROTINA_TAREFAS_CHANGE',payload);
            },
            mtdgerenciartarefa(idtarefa){
                this.optarefa = 1;
                this.idtarefa = idtarefa;
                let payload = {
                    abrirtela    : true			
                };
                this.$store.commit('ROTINA_TAREFAS_CHANGE',payload);                
            },
            mtdmostrapicovendas(picovendas, diasemana){
                let vself = this;
                vself.diaselecionado = diasemana;
                vself.mtdhoramaiorquantidade(picovendas);
                vself.agrupamentohoras          = [];                            
                vself.agrupamentoquantidades    = [];                                        				
                let agr1 = [];
                let agr2 = [];
                if (picovendas.length > 0){
                    for (let i = 0; i < picovendas.length; i++) {
                        picovendas[i];
                        agr1.push(picovendas[i].hora+':00');                            
                        agr2.push(picovendas[i].quantidade);
                    }
                }
                vself.agrupamentohoras          = agr1;                            
                vself.agrupamentoquantidades    = agr2;                
            },
            mtdhoramaiorquantidade(arr) {            
                let maiorQuantidade = 0;
                let horaMaiorQuantidade = "";

                for (let i = 0; i < arr.length; i++) {
                    const quantidade = parseInt(arr[i].quantidade);
                    if (quantidade > maiorQuantidade) {
                    maiorQuantidade = quantidade;
                    horaMaiorQuantidade = arr[i].hora;
                    }
                }
                this.hrmaior = horaMaiorQuantidade;
            },
            async listaratzs() {
                const vself = this;
                let filtranews = [];
                let filtrapubli = [];
                const parametros = [
                    { parametro: 'idclientesac', valor: vself.$store.state.usuario.idclientesac },
                    { parametro: 'idusuario',    valor: vself.$store.state.usuario.id },
                    { parametro: 'param1',       valor: 'listaratz' },
                ];

                try {
                    const response = await util.reqaxios(parametros, 'post', 'rillsoft.app/sacweb/controller/rotinanewsatz.php');
                    // console.log(response.data);
                    filtranews = response.data.reverse().filter(news => news.tpatualizacao == 0);
                    vself.newsconteudoexibir = filtranews[0] || {};
                    vself.publiconteudoexibir = response.data.reverse().filter(news => news.tpatualizacao == 1);
                    return response.data? response.data : [];
                } catch (error) {
                    vself.$toastr.e('Ocorreu um erro ao carregar as novidades: ' + (error?.data || error), 'Informação!');
                    return [];
                }
            },
            visualizanews(conteudo){
                this.newsconteudoexibir = {};
                this.newsconteudoexibir = {
                    ...conteudo,
                    idcarrossel: 'carousel_' + conteudo.id + '_' + Math.random().toString(36).substr(2, 6)
                };
            },
            async mdthistoricoatv() {
                const vself = this;
                const periodo = vself.pdatv;
                const parametros = [
                    { parametro: 'idclientesac', valor: vself.$store.state.usuario.idclientesac },
                    { parametro: 'idusuario',    valor: vself.$store.state.usuario.id },
                    { parametro: 'idfilial',     valor: vself.$store.state.filialpadrao.codfil },
                    { parametro: 'periodo',      valor: periodo },
                    { parametro: 'op',           valor: 'consultahistoricoacoes' },
                ];

                try {
                    const response = await util.reqaxios( parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/telaprincipal.php');
                    return response.data; 
                } catch (error) {
                    vself.$toastr.e('Ocorreu um erro ao carregar o histórico de atividades: ' + (error?.data || error), 'Informação!');
                    return []; 
                }
            },
            async mtdlistafavs() {
                const vself = this;
                const parametros = [
                    { parametro: 'idclientesac',    valor: vself.$store.state.usuario.idclientesac },
                    { parametro: 'op',              valor: 'consultafavoritos' },
                    { parametro: 'idusuario',       valor: vself.$store.state.usuario.id }
                ];

                try {
                    const response = await util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/telaprincipal.php');
                    return response.data;
                } catch (error) {
                    vself.$toastr.e('Ocorreu um erro ao carregar os atalhos favoritos: ' + (error?.data || error), 'Informação!');
                    return [];
                }
            },
            mdlhistoricoatv(){
                $('#mdlhistoricoatv').modal('show');
            },
            mdlfavoritos(){
                $('#mdlfav').modal('show');
            },
            mtdformadardataextenso(data, mostrahr) {
                if (!mostrahr) {
                    return util.dataextenso(util.InverterData(data) + 'T00:00:00');
                }else{
                    let vdthr = data.split('T');
                    let vhr   = vdthr[1].split(':');
                    return util.dataextenso(util.InverterData(data) + 'T00:00:00')+' às '+vhr[0]+':'+vhr[1];
                }
            },
            mtdtransformadata: function(dttrasnf){
                return util.formatadatahrdb(dttrasnf);
            },
            removerAcento(texto) {
                return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            },
            buscarIconeEcor(descricao) {
                const cleanedDescricao = this.removerAcento(descricao.toLowerCase());

                if (cleanedDescricao.includes('tecnico')) {
                return { icon: 'fa-wrench', color: '#28a745' }; 
                } else if (cleanedDescricao.includes('filial')) {
                return { icon: 'fa-building', color: '#6f42c1' }; 
                } else if (cleanedDescricao.includes('situacao de cheque')) {
                return { icon: 'fa-credit-card', color: '#ffc107' }; 
                } else if (cleanedDescricao.includes('municipio') || cleanedDescricao.includes('bairro')) {
                return { icon: 'fa-map-marker', color: '#17a2b8' }; 
                } else if (cleanedDescricao.includes('usuario')) {
                return { icon: 'fa-user', color: '#e83e8c' };
                } else if (cleanedDescricao.includes('produto' )) {
                return { icon: 'fa-cube', color: '#dc3545' }; 
                } else if (cleanedDescricao.includes('compra') || cleanedDescricao.includes('venda')) {
                return { icon: 'fa-shopping-cart', color: '#20c997' }; 
                } else if (cleanedDescricao.includes('cliente')) {
                return { icon: 'fa-users', color: '#007bff' }; 
                } else if (cleanedDescricao.includes('template') || cleanedDescricao.includes('relatorio')) {
                return { icon: 'fa-file-text-o', color: '#fd7e14' }; 
                } else if (cleanedDescricao.includes('pdv')) {
                return { icon: 'fa-desktop', color: '#6c757d' }; 
                } else if (cleanedDescricao.includes('faturou')) {
                return { icon: 'fa-usd', color: '#6c757d' }; 
                } else if (cleanedDescricao.includes('Template')) {
                return { icon: 'fa-file-text-o', color: '#6c757d' }; 
                } else {
                return { icon: 'fa-pencil', color: '#343a40' };
                }
            },
            mtdnewsfeeadback(indice){
                let feedback = null;

                if((parseInt(this.newslike)===0)&&(parseInt(this.newsdeslike)===0)){
                    this.$toastr.w('Informe o seu Feedback!', 'Informação!');
                    return
                }
                if(this.newscomentario ===''){
                    this.$toastr.w('Informe o seu comentário!', 'Informação!');
                    return
                }
                if(parseInt(this.newslike)===1){
                    feedback = 1
                }

                if(parseInt(this.newsdeslike)===1){
                    feedback = 0
                }

                let comentario  = this.newscomentario
                let id          = indice

                var vself       = this;
                let parametros  = [
                    {parametro: 'idclientesac', valor : vself.$store.state.usuario.idclientesac},
                    {parametro: 'param1',       valor : 'enviarfeedback'},
                    {parametro: 'idatz',        valor : id },
                    {parametro: 'feedback',     valor : feedback },
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'nomeusuario',  valor : vself.$store.state.usuario.nome},
                    {parametro: 'comentario',   valor : comentario},
                    
                ];
                let retorno           = util.reqaxios(parametros, 'post', 'rillsoft.app/sacweb/controller/rotinanewsatz.php');
                retorno.then(function (response) {
                    
                    if($.isNumeric(response.data)){
                        vself.$toastr.s('Obrigado pelo feedback!', 'Informação!');
                    }else{
                        vself.$toastr.e('Ocorreu um erro inesperado: '+response.data, 'Informação!');
                        
                    }
                    vself.mtdcarregadash();
                }).catch(function (response) {
                    vself.$toastr.e('Ocorreu um erro ao enviar o feedback: ' + response.data, 'Erro');
                    vself.mtdcarregadash();
                });



            },   
            mtdnewslike(op){
                // no furuto vou ajeitar a logica para deixar mais limpa - bruno (nao julguem o meu 'impa ou pa')
                if(op==1){
                    this.newslike = 1;
                    this.newsdeslike = 0;
                }if (op==2){
                    this.newsdeslike = 1;
                    this.newslike = 0; 
                }
                if(op==3){
                    this.newslike = 0;
                    this.newsdeslike = 0;
                    this.newscomentario = '';
                }

            },
            mtdgotofav(caminho){
                const rota = caminho.replace('/', '');
                window.open(window.location.href + rota)
            },
            mtdiconefav(codop) {
            if (!codop) return 'fa fa-question-circle'; // ícone padrão se codop for inválido

            const prefixo = codop.split('.')[0].toUpperCase();

            const mapaIcones = {
            '001Z': 'fa fa-table',
            '002Z': 'fa fa-archive',
            '010Z': 'fa fa-cube',
            '020Z': 'fa fa-calculator',
            '030Z': 'fa fa-bank',
            '035Z': 'fa fa-money',
            '040Z': 'fa fa-print'
            };

            return mapaIcones[prefixo] || 'fa fa-question-circle'; // ícone padrão caso não encontre
            },
            mtdremovefav(rota) {
                var vself = this;
                let parametros = [
                    { parametro: 'idclientesac', valor: vself.$store.state.usuario.idclientesac },
                    { parametro: 'op', valor: 'favoritosusuario' },
                    { parametro: 'routerfav', valor: rota },
                    { parametro: 'idusuario', valor: vself.$store.state.usuario.id },
                ];

                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rotinasusuario.php');
                
                retorno.then(function (response) {
                    vself.mtdcarregadash();
                }).catch(function (response) {
                    vself.$toastr.e('Erro ao remover favorito: ' + response.data, 'Erro');
                    vself.mtdcarregadash();
                });
            },
            formatarDescricaoFavorito(chave, codop) {
                try {
                    const arr = JSON.parse(chave);
                    const palavra = arr[0] || '';
                    if(codop == '040Z.010Z'){
                        return 'Rel. Estoque' 
                    }else if(codop == '040Z.020Z'){
                        return 'Rel. Vendas'
                    }else{
                        return palavra.charAt(0).toUpperCase() + palavra.slice(1); 
                    }
                } catch (e) {
                    return chave;
                }
            },
            mtdvalidaurl(string) {
                try {
                    new URL(string);
                    return true;
                } catch (e) {
                    return false;
                }
            },
            mtdabrirlink(link){
                if(link.trim() !== ''){
                    let links = this.mtdvalidaurl(link);
                    if(links){
                        window.open(link, '_blank');
                    }else{
                        this.$router.push(link);
                    }
                }
            },


            
           
        },
        mounted: function () {  
            if(this.usuariologado.id !== null){
                if (util.verificasessao(this)) {
                    let vself = this;
                    vself.isloading = true;
                    let parametros = [
                        {parametro: 'op', valor: 'dadosusuario'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                        {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                    ];
                    let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                    retorno.then(function (response) {
                        vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                        vself.mtdcarregadash();
                    }).catch(function (response) {
                        vself.isloading = false;
                        vself.$toastr.e('Erro ao carregar os dados do usuário: ' + response.data, 'Erro');
                        vself.mtdcarregadash();
                    });
                }
            }
        
        },
        computed:{
            telatarefa(){//variável para verificar se o usuário fechou o modal das tarefas
                return this.$store.state.rotinatarefas.abrirtela;                
            },     
            usuariologado(){
                return this.$store.state.usuario;
            },           
            cfilialpadrao(){
                return this.$store.state.filialpadrao;
            },
            filtratarefas(){
                $('#sbsituacaotarefas').selectpicker('val');
            }
        },
    watch:{
        telatarefa(val){//atualiza os dados da dashboard quando o usuário fecha a tela da tarefa
            if (!val){
                this.mtdresultadofaturamento();
            }               
        },
        usuariologado(val){
             this.mtdcarregadash();
        },
        filtratarefas(){
            this.mtdBuscaFiltradaTarefas()
        },
        cfilialpadrao(){
            this.mtdcarregadash();
        }
    }, 
}
</script>
<style>
    .tooltip-message-fav {
        width: 400px;
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%) translateY(10px);
        background-color: #ffffff;
        border: 2px solid #e2e8f0; 
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
        border-radius: 0.75rem; 
        z-index: 19999;
        
        img {
            padding: 10px;
            background-color: #ffffff;
            width: 100%;
            border: 4px solid #e7e7e7;
        }
    }

    div .tooltip-message-fav div {
        background-color: #e7e7e7;
        padding: 10px;
    }
    div .tooltip-message-fav div p {
        font-size: 13px;
        color: #727272;
        font-weight: 500;
        margin-bottom: 0;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
    .card-dash{
        height: 45px;
        padding: 10px 15px!important;
        background: white!important;
        border-bottom: 1px solid #00000020!important;        
    }
    .tit-card-dash{
        color: #666666!important;
        font-weight: 500!important;        
    }
    .li-item-card-dash{
        list-style-type: none;
    }
    .txt-item-card-dash{
        font-size: 12px;
        color: #666666;
        font-weight: 700;
    }
    .txt-item-card-dash-grafico{
        font-size: 10px;
        color: #666666;
        font-weight: 600;        
    }
    .txt-item-card-dash-top5-desc{
        font-size: 10px;
        color: #666666;
        font-weight: 600; 
        max-width: 280px!important; 
        overflow: hidden; 
        text-overflow: ellipsis; 
        white-space: nowrap;                
    }   
    .txt-item-card-dash-top5-val{
        font-size: 10px;
        color: #666666;
        font-weight: 600;        
    }    
    .txt-item-card-dash-top10-desc{
        font-size: 10px;
        color: #666666;
        font-weight: 600; 
        max-width: 280px!important; 
        overflow: hidden; 
        text-overflow: ellipsis; 
        white-space: nowrap;                
    }   
    .txt-item-card-dash-top10-val{
        font-size: 10px;
        color: #666666;
        font-weight: 600;        
    }    
    .btn-muda-top5{
        margin-right: 5px!important;
        font-size: 10px!important;
        width: 20px!important;
        height: 20px!important;
        padding: 2px!important;
        margin-top: -5px!important;        
    }
    .card-tarefas{
        min-height: 154px!important;
        /* background: #727cf5!important; */
        background-image: linear-gradient(to right, #19218b, #2029a2, #2731b9, #2e3ad1, #3543e9);
        
        border-radius: 15px!important;
    }
    .pb-tarefa{
        background: #727cf5!important;
        font-size: 10px!important;
    }
    .bgd-st-tarefa{
        width: 73px;
    }
    .btn-light{
        background: #fbfbfb!important;
    }   
    .dia-selecionado{
        border-bottom: 4px solid #0acf97!important;
    } 

    .container-sem-fav{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        margin-inline: auto;
    }

    .sem-favoritos-img img {
        width: 25px;
    }

    .sem-favoritos{
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        cursor: default;
    }

    .sem-favoritos span {
        text-align: center;
        font-size: 14px;
        color: #666666;
        font-weight: 600;
    }

    .sem-favoritos p {
        text-align: center;
        font-size: 12px;
        color: #999999;
        font-weight: 400;
    }

    .sem-favoritos i{
        animation: piscar 1s infinite;
    }
    
    .container-sem-hist{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        margin-inline: auto;
    }

    .sem-historico-img img {
        width: 25px;
    }

    .sem-historico{
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        cursor: default;
    }

    .sem-historico span {
        text-align: center;
        font-size: 14px;
        color: #666666;
        font-weight: 600;
    }

    .sem-historico p {
        text-align: center;
        font-size: 12px;
        color: #999999;
        font-weight: 400;
    }

    .sem-favoritos i{
        animation: piscar 1s infinite;
    }

    @media (max-width: 344px) {
        .valconainer{
            padding: 0 !important;
        }      
    }  
    @media (max-width: 576px) {
        .grafico-metavendedores .echarts {
            width: 300px;
            height: 100px;
        }        
    }  
    @media (min-width: 577px) {
        .grafico-metavendedores .echarts {
            width: 500px;
            height: 300px;
        }        
    }  
    @media (min-width: 1024px) {
        .grafico-metavendedores .echarts {
            width: 1024px;
            height: 400px;
        }       
    }  
    @media (min-width: 1257px) {
        .notasalert{
            left: 178px;
             top: 29px;
        }
    }  
    @media (min-width: 1200px) {
        .notasalert{
            left: 170px;
             top: 29px;
        }
    }  
    @media (min-width: 1001px) {
        .notasalert{
            position: absolute;
            left: 170px;
             top: 29px;
        }
        .popover-arrow {
            position: absolute;
            top: -10px; /* Posiciona a seta acima do popover */
            left: 168px !important; /* Centraliza a seta abaixo do ícone */
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-bottom: 10px solid #f8f9fa; /* Cor da seta, combinando com o fundo do popover */
          }
    }  
    .notasalert {
         animation: piscar 1s infinite;
         color: red;
    }
    @keyframes piscar {
        0% {
            opacity: 1;
        }
        50% {
            opacity: 0.5;
        }
        100% {
            opacity: 1;
        }
    }

    @keyframes pulse {
        0% {
            transform: scale(1);
            opacity: 1;
        }
        50% {
            transform: scale(1.2);
            opacity: 0.7;
        }
        100% {
            transform: scale(1);
            opacity: 1;
        }
    }
    .popover-container {
        position: absolute;
        top: 60px; /* Ajusta a posição do popover */
        left: 0;
        background-color: #f8f9fa;
        padding: 10px;
        border-radius: 5px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        z-index: 1000;
        width: 200px; /* Ajuste de largura */
      }
      
      /* Seta do popover */
      .popover-arrow {
        position: absolute;
        top: -10px; /* Posiciona a seta acima do popover */
        left: 20px; /* Centraliza a seta abaixo do ícone */
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid #f8f9fa; /* Cor da seta, combinando com o fundo do popover */
      }
      
      /* Conteúdo do popover */
      .popover-content {
        position: relative;
        z-index: 1; /* Garante que o conteúdo fique acima da seta */
      }

      .lstnews{
        max-height: 100%;
        overflow: hidden;
        
      }
      .lstnews > div {
        flex: 0 0 auto;
        margin-bottom: 10px;
      }
      .cardnews{
        height: 100%;
        flex-grow: 1;
        overflow-x: hidden; 
        overflow-y: auto;
        padding: 0 !important;
      }
    .cardnews::-webkit-scrollbar {
        width: 4px;
    }
    .cardnews::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }
    .cardnews::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 4px;
    }
    .estilo_tarefas::-webkit-scrollbar {
        width: 4px;
    }
    .estilo_tarefas::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }
    .estilo_tarefas::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 4px;
    }
    
      @media (max-width: 576px) {
        .lstnews {
            order: 1 ;
            display: flex ;
            flex-direction: row ;
            overflow-x: auto ;
            overflow-y: hidden ;
            white-space: nowrap ;
            width: 100%;
            gap: 10px;
            margin-bottom: 15px;
        }
       
        .lstnews::-webkit-scrollbar {
            height: 2px;
        }

        .lstnews::-webkit-scrollbar-thumb {
            background-color: rgba(168, 5, 5, 0.2);
            border-radius: 3px;
        }
         div .cardnews {
            order: 2 ;
            overflow-y: auto;

        }
        }
    .listanews {
        padding-block: 10px;
        border-left: 5px solid #1d25a0;
        box-shadow: 0 8px 20px rgba(0,0,0,0.10);
        border-radius: 8px;
        transition: 0.3s;
        background-color: white;
    }
    .listanews:hover {
        background-color: #f5f7fb;
        box-shadow: 0 12px 24px rgba(0,0,0,0.3);
        transform: scale(1.0);
        cursor: pointer;
    }

    .card-visualizado {
        border-left: none ;
        opacity: 0.7;
        box-shadow: 0 2px 8px rgba(0,0,0,0.05); 
        filter: grayscale(20%);
        transform: scale(0.98);
        transition: 0.3s;
    }
    .cardfav:hover{
        background-color: #f1f1f1;
    }
    .cardfav{
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        background-color: #fafafa;
        color: #495057;
        font-weight: 500;
        padding: 0.5rem 1rem;
        border-radius: 50rem;
        cursor: pointer;
        transition: background-color 0.2s;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.10) ; 
    }
    .card-custom {
        height: 100;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .card-descricao {
        font-weight: bold;
        font-size: small;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .card-data {
        font-size: small;
        color: #555;
        text-overflow: ellipsis;
    }
    @keyframes bounce {
        0%, 100% {
            transform: translateY(0);
        }
        50% {
            transform: translateY(-5px);
        }
    }
    .bounce-icon {
        animation: bounce 1s infinite;
    }

    div .card-anuncio{
        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    }
    @media (max-width: 980px) {
        .lstnews {
            padding: 5px !important;
        }
        .lstnews > div {
            width: 70%;
        }
        .lstnews::-webkit-scrollbar {
            width: 5px;
        }
        .lstnews::-webkit-scrollbar-track {
            background: transparent !important; 
        }
        .lstnews::-webkit-scrollbar-thumb {
            border-radius: 3px;
        }
        div .margin-card{
            margin-bottom: 13px ;
        }
        div .body-favoritos{
            height: fit-content ;
        }
        div .card-anuncio{
            height: fit-content ;

            img {
                width: 100% ;
                height: auto ;
            }
        }
        div .cardnews {
            height: 450px ;
        }
    }
</style>